








































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
import BankingIntegrations from '@/components/Settings/Institutions/Integrations/Banking/BankingIntegrations.vue';
import CardIntegrations from '@/components/Settings/Institutions/Integrations/Card/CardIntegrations.vue';
import ExchangesIntegrations from '@/components/Settings/Institutions/Integrations/Exchanges/ExchangesIntegrations.vue';
import TransactionMonitoringIntegrations from '@/components/Settings/Institutions/Integrations/TransactionMonitoring/TransactionMonitoringIntegrations.vue';

@Component({ name: 'InstitutionIntegrations', components: { BankingIntegrations, CardIntegrations, ExchangesIntegrations, TransactionMonitoringIntegrations } })
export default class extends SaascadaVue {

    tabIndex = 0;

    get config() {
        return AuthModule.me.institution.config;
    }

}
